import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Marketplace } from './pages/Marketplace';
import { Checkout } from './pages/Checkout';
import { Admin } from './pages/Admin';
import { VisionPage } from './pages/VisionPage';
import { PartnerPage } from './pages/PartnerPage';
import { CartProvider } from './CartContext';
export function App() {
  return <CartProvider data-id="element-0" data-mp="2mmvlkvs92ic2">
      <BrowserRouter data-id="element-1" data-mp="2mndpmel5m0uj">
        <div className="flex min-h-screen w-full flex-col bg-warm text-brun" data-id="element-2" data-mp="2mjpxnjvcxmhx">
        <Navbar data-id="element-3" data-mp="31c9tdzg6grpc" />
        <main className="flex-1" data-id="element-4" data-mp="31ctfztgrw49p">
          <Routes data-id="element-5" data-mp="2wjgqlh49rtfw">
            <Route path="/" element={<Home data-id="element-7" data-mp="2wifh3h2wjf0a" />} data-id="element-6" data-mp="2wiyy8vkq9zd9" />
            <Route path="/utbud" element={<Marketplace data-id="element-9" data-mp="28tw62tsgwo4i" />} data-id="element-8" data-mp="2wi5mthatqlos" />
            <Route path="/partner/:slug" element={<PartnerPage data-id="element-11" data-mp="28s2y9b64bxux" />} data-id="element-10" data-mp="28t4lsf4bmctj" />
            <Route path="/vision" element={<VisionPage data-id="element-13" data-mp="23ujmchww7x65" />} data-id="element-12" data-mp="23vunsb2v8su3" />
            <Route path="/bestall" element={<Checkout data-id="element-15" data-mp="3ik7e6ay3c1o0" />} data-id="element-14" data-mp="23t8g8bfz6dbv" />
            <Route path="/admin" element={<Admin data-id="element-17" data-mp="3ijpe138b53at" />} data-id="element-16" data-mp="3iiwfuqnezm4a" />
          </Routes>
        </main>
        <Footer data-id="element-18" data-mp="3mkrbpfmkt7ao" />
      </div>
      </BrowserRouter>
    </CartProvider>;
}